import { SAM_POWER_USER_UP, SAM_SUPER_USER_UP } from '../common/constants/sam';
import { sam } from '../../DataAccessLayer/services';

export const PageDetails = {
  sam: {
    id: 'studentAdvisorManagement',
    title: 'Student Advisor Management',
    url: 'sam',
  },
  'student-search': {
    id: 'studentSearch',
    page: 'student-search',
    title: 'Student Search',
    url: 'student-search',
  },
  'advisor-summary': {
    id: 'advisorSummary',
    page: 'advisor-summary',
    title: 'Advisor Summary',
    url: 'advisor-summary',
    required: [SAM_POWER_USER_UP],
  },
  'student-assigned': {
    id: 'advisorsAssignedStudents',
    page: 'student-assigned',
    title: 'Advisors Assigned Students',
    url: 'student-assigned',
  },
  'student-change-major': {
    id: 'studentsWithDifferentMajor',
    page: 'student-change-major',
    title: 'Students Who Have Selected a Different Major',
    url: 'student-change-major',
  },
  'student-unassigned': {
    id: 'unassignedStudents',
    page: 'student-unassigned',
    title: 'Unassigned Students',
    url: 'student-unassigned',
  },
  'student-missing-advisor-code': {
    id: 'studentsWithMissingAdvisorCode',
    page: 'student-missing-advisor-code',
    title: 'Students with Missing Advisor Code',
    url: 'student-missing-advisor-code',
    required: [SAM_POWER_USER_UP],
  },
};

export const AdminPageDetails = {
  'auto-assignment-report': {
    id: 'autoAssignmentReport',
    page: 'auto-assignment-report',
    title: 'Auto Assignment Report',
    url: 'auto-assignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Auto Assignment Report',
  },
  'diff-major-auto-unassignment-report': {
    id: 'diffMajorAutoUnassignmentReport',
    page: 'diff-major-auto-unassignment-report',
    title: 'Different Major Auto Unassignment Report',
    url: 'diff-major-auto-unassignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Different Major Auto Unassignment Report',
  },
  'inactive-auto-unassignment-report': {
    id: 'inactiveAutoUnassignmentReport',
    page: 'inactive-auto-unassignment-report',
    title: 'Inactive Students Auto Unassignment Report',
    url: 'inactive-auto-unassignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Inactive Students Auto Unassignment Report',
  },
  'rules-update-report': {
    id: 'rulesUpdateReport',
    page: 'rules-update-report',
    title: 'Rules Update Report',
    url: 'rules-update-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Rules Update Report',
  },
};

export const AdvisorTypes = [
  {
    type: 'A',
    label: 'All',
  },
  {
    type: 'P',
    label: 'Primary',
  },
  {
    type: 'S',
    label: 'Secondary',
  },
];

export const DefaultDepartment = {
  STVDEPT_CODE: 'All',
  STVDEPT_DESC: '',
  STVDEPT_INFO: '',
};

export const SiteCodeCampusMapping = {
  100: 'On Campus',
  500: 'Online - In VA',
  700: 'Online - Out of State',
  '8OU': 'International',
};
